import { createContext, type ReactNode } from "react"

export interface IPageTitleContext {
  title: ReactNode
  setTitle: (title: ReactNode) => void
}

export const PageTitleContext = createContext<IPageTitleContext>({
  title: null,
  setTitle: () => null,
})
